import React from "react"

export default function Navbar() {
    return (
        <div className="navbar">
            <img src="./assets/logo.png" className="logo"/>
            <h1>studyBuddies</h1>
        </div>
    )
}